import { setElementManipulationModeAction as setElementManipulationModeOperation } from 'editor/src/store/editor/slice';

export default setElementManipulationModeOperation;
